import usePageMeta from '../../hooks/usePageMeta';
import { profile } from '../../data/profile';
import Reveal from '../../components/motion/Reveal';
import Intro from './Intro';
import { Work, Experience, Contact } from './Sections';

export default function Home() {
  usePageMeta(`${profile.name} — ${profile.role}`, profile.description);
  return (
    <>
      <Intro />
      <Reveal>
        <Work />
      </Reveal>
      <Reveal>
        <Experience />
      </Reveal>
      <Reveal>
        <Contact />
      </Reveal>
    </>
  );
}
